import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled from "styled-components";
import { HexColorPicker } from "react-colorful";
import { Label, Dropdown, InputText } from "~/components-shared";
const Wrapper = styled.div`
  ${_ref => {
  let {
    $s,
    theme
  } = _ref;
  return theme.spacing.resolve(theme, $s);
}};
  ${_ref2 => {
  let {
    $fullWidth
  } = _ref2;
  return $fullWidth && "width: 100%";
}};
  ${_ref3 => {
  let {
    $maxWidth
  } = _ref3;
  return $maxWidth && `max-width: ${$maxWidth}`;
}};
`;
const Field = styled.div`
  background-color: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.background.dark;
}};
  width: 100%;
  border: none;
  border-radius: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme.shape.borderRadius.primary;
}};
  font-weight: ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.typography.fontWeight.regular;
}};
  display: flex;
  align-items: center;
  transition: box-shadow 200ms ease-in;
  box-shadow: rgb(255 255 255) 0 0 0 0, transparent 0 0 0 1px;
  ${_ref7 => {
  let {
    $outline,
    $hasError,
    theme
  } = _ref7;
  return theme.shadows.outline(theme, $outline, $hasError ? theme.colors.danger.main : theme.colors.primary.main);
}}
`;
const Error = styled.span`
  font-size: 0.8rem;
  display: inline-block;
  margin-left: 0.5rem;
  color: ${_ref8 => {
  let {
    theme
  } = _ref8;
  return theme.colors.danger.main;
}};
`;
const Color = styled.div`
  width: 1.4rem;
  height: 1.4rem;
  background-color: ${_ref9 => {
  let {
    $color,
    theme
  } = _ref9;
  return $color || theme.colors.borders.secondary;
}};
  border-radius: 50%;
  margin-right: 0.6rem;
`;
const StyledDropdownList = styled(Dropdown.List)`
  padding: 1rem;
`;
const InputColor = _ref10 => {
  let {
    label,
    value = "",
    direction = "bottomRight",
    error,
    onChange = () => false,
    required = false,
    disabled = false,
    maxWidth,
    fullWidth = false,
    s,
    outline,
    children,
    labelProps,
    ...rest
  } = _ref10;
  const customHandler = (toggle, isOpen) => /*#__PURE__*/React.createElement(Field, {
    onClick: toggle,
    $outline: isOpen || outline,
    $hasError: false
  }, /*#__PURE__*/React.createElement(InputText, _extends({
    value: value,
    onChange: onChange,
    elemBefore: /*#__PURE__*/React.createElement(Color, {
      $color: value
    }),
    autoComplete: "off",
    outline: false
  }, rest)));
  return /*#__PURE__*/React.createElement(Wrapper, {
    $s: s,
    $maxWidth: maxWidth,
    $fullWidth: fullWidth
  }, !!label && /*#__PURE__*/React.createElement(Label, _extends({
    required: required,
    disabled: disabled,
    s: {
      mb: 2
    }
  }, labelProps), label), /*#__PURE__*/React.createElement(Dropdown, {
    direction: direction,
    customHandler: customHandler
  }, _ref11 => {
    let {
      isOpen
    } = _ref11;
    return /*#__PURE__*/React.createElement(StyledDropdownList, {
      isOpen: isOpen
    }, /*#__PURE__*/React.createElement(HexColorPicker, {
      color: value,
      onChange: onChange
    }));
  }), error && /*#__PURE__*/React.createElement(Error, null, error));
};
export default InputColor;